import React, { useState, useEffect } from 'react';
import './css/ImageWithPlaceholder.css';

const ImageWithPlaceholder = ({ src, alt, className }) => {
    const [imgSrc, setImgSrc] = useState(src);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        setImgSrc(src);
        setIsError(false);
    }, [src]);

    const handleError = () => {
        setIsError(true);
    };

    if (isError || !imgSrc) {
        return (
            <div className={`image-placeholder ${className || ''}`}>
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#cccccc" strokeWidth="1.5">
                    <path d="M21.25 4.75H2.75C2.58424 4.75 2.42527 4.81585 2.30806 4.93306C2.19085 5.05027 2.125 5.20924 2.125 5.375V18.625C2.125 18.7908 2.19085 18.9497 2.30806 19.0669C2.42527 19.1842 2.58424 19.25 2.75 19.25H21.25C21.4158 19.25 21.5747 19.1842 21.6919 19.0669C21.8092 18.9497 21.875 18.7908 21.875 18.625V5.375C21.875 5.20924 21.8092 5.05027 21.6919 4.93306C21.5747 4.81585 21.4158 4.75 21.25 4.75V4.75Z" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8.75 11.25C9.7165 11.25 10.5 10.4665 10.5 9.5C10.5 8.5335 9.7165 7.75 8.75 7.75C7.7835 7.75 7 8.5335 7 9.5C7 10.4665 7.7835 11.25 8.75 11.25Z" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M21.875 15.25L16.25 9.625L7 18.875" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>
        );
    }

    return <img src={imgSrc} alt={alt} className={className} onError={handleError} />;
};

export default ImageWithPlaceholder; 